import type { ReactNode, CSSProperties } from 'react';

export interface MenuSectionProps {
  /** Section content */
  children: ReactNode;
  /** Additional className */
  className?: string;
  /** Additional styles */
  style?: CSSProperties;
}

const sectionStyles: CSSProperties = {
  paddingTop: 'var(--uiv2-menu-section-py, 10px)',
  paddingBottom: 'var(--uiv2-menu-section-py, 10px)',
  paddingLeft: 'var(--uiv2-menu-section-px, 16px)',
  paddingRight: 'var(--uiv2-menu-section-px, 16px)',
};

/**
 * MenuSection - renders static content within a menu (header, footer, labels, etc.)
 *
 * No hover effects - used for non-interactive content areas.
 *
 * @example
 * ```tsx
 * <Menu>
 *   <MenuSection>Actions</MenuSection>
 *   <MenuItem onClick={handleEdit}>Edit</MenuItem>
 *   <MenuSeparator />
 *   <MenuSection>
 *     <Button size="sm">Apply</Button>
 *   </MenuSection>
 * </Menu>
 * ```
 */
export function MenuSection({ children, className = '', style }: MenuSectionProps) {
  return (
    <div
      className={`shrink-0 w-full text-uiv2-dropdown-item-text ${className}`}
      style={{ ...sectionStyles, ...style }}
    >
      {children}
    </div>
  );
}
